import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function RunOrDie() {






    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">RunOrDie</h2>
                <div className='folder-porfolio'>


                    <iframe src="https://www.youtube.com/embed/F5tuGQg71uw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

                    <div className="list" >



                        {tecno.filter(tec => tec.T === 'Unity' || tec.T === 'C#').map(tec => (


                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>
                        This game was created with Unity and consists of escaping from the steamroller so as not to die,
                        the terrain is procedural so in general it has no end! You accumulate points the further you
                        advance in the game.
                    </p>

                    <a href="https://github.com/BrandonGrimaldoM/RunOrDieGame" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>

                <div className='after'>
                    <Link to="/video-games" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>

            </section>
        </React.Fragment>
    );
}
export default RunOrDie;